export const SET_TRANSACTIONS_ERROR = 'SET_TRANSACTIONS_ERROR';
export const SET_TRANSACTIONS_LIST = 'SET_TRANSACTIONS_LIST';
export const SET_TOTAL_AMOUNT_OF_TRANSACTIONS = 'SET_TOTAL_AMOUNT_OF_TRANSACTIONS';
export const SET_FETCHING_TRANSACTIONS = 'SET_FETCHING_TRANSACTIONS';
export const SET_TRANSACTION_TYPES = 'SET_TRANSACTION_TYPES';
export const SET_ENTITY_TYPES = 'SET_ENTITY_TYPES';
export const SET_TRANSACTION_FILTERS = 'SET_TRANSACTION_FILTERS';
export const SET_INSURED_PROJECTS_MAPPINGS = 'SET_INSURED_PROJECTS_MAPPINGS';
export const SET_INSURED_PROJECTS_MAPPINGS_ERROR    = 'SET_INSURED_PROJECTS_MAPPINGS_ERROR';
